import React from 'react';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import { NoteWrapper, NoteText } from './styles';

const GroupResolutionNote: React.FunctionComponent<{ children: React.ReactNode }> = ({ children }) => (
  <NoteWrapper>
    <InfoOutlinedIcon />
    <NoteText>{children}</NoteText>
  </NoteWrapper>
);

export default GroupResolutionNote;
